import { createBrowserRouter } from 'react-router-dom';

import Home from 'routes/Home/Home';
import Login from 'routes/Login/Login';
import ProjectDashboard from 'routes/ProjectDashboard/ProjectDashboard';
import Users from 'routes/Users/Users';
import UserSignUp from 'routes/UserSignUp/UserSignUp';
import Export from 'routes/Export/Export';
import Profile from 'routes/Profile/Profile';
import PasswordReset from 'routes/Login/PasswordReset';
import ProjectSelector from 'routes/Projects/ProjectSelector';
import { ProtectedRoute } from 'routes/ProtectedRoute';
import { RoutePaths } from 'types/types';
import ProjectEditor from 'routes/ProjectEditor/ProjectEditor';
import UserEditor from 'routes/UserEditor/UserEditor';
import PatientEditor from 'routes/PatientEditor/PatientEditor';
import PatientDetails from 'routes/PatientDetails/PatientDetails';
import NewPassword from 'routes/Login/NewPassword';
import FormTemplateEditor, {
  FormTemplateEditorMode,
} from 'routes/FormTemplateEditor/FormTemplateEditor';
import ProjectFormLists from 'routes/ProjectFormLists/ProjectFormLists';
import Form from 'routes/Form/Form';
import Patients from 'routes/Patients/Patients';
import Import from 'routes/Import/Import';
import ReportTemplates from './routes/ReportTemplates/ReportTemplates';
import ReportTemplateEditor from './routes/ReportTemplateEditor/ReportTemplateEditor';

export default createBrowserRouter([
  {
    path: RoutePaths.root,
    element: <Login />,
  },
  {
    path: RoutePaths.login,
    element: <Login />,
  },
  {
    path: RoutePaths.passwordReset,
    element: <PasswordReset />,
  },
  {
    path: RoutePaths.newPassword,
    element: <NewPassword />,
  },
  {
    path: RoutePaths.registerUser,
    element: <UserSignUp />,
  },
  {
    path: RoutePaths.home,
    element: (
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    ),
    children: [
      {
        path: RoutePaths.formTemplateEditor,
        element: <FormTemplateEditor mode={FormTemplateEditorMode.default} />,
      },
      {
        path: RoutePaths.formTemplateEditorView,
        element: (
          <FormTemplateEditor mode={FormTemplateEditorMode.default} viewOnly />
        ),
      },
      {
        path: RoutePaths.sampleTemplateEditor,
        element: <FormTemplateEditor mode={FormTemplateEditorMode.sample} />,
      },
      {
        path: RoutePaths.sampleTemplateEditorView,
        element: (
          <FormTemplateEditor mode={FormTemplateEditorMode.sample} viewOnly />
        ),
      },
      {
        path: RoutePaths.patients,
        element: <Patients />,
      },
      {
        path: RoutePaths.patientEditor,
        element: <PatientEditor mode="edit" />,
      },
      {
        path: RoutePaths.patientViewer,
        element: <PatientEditor mode="view" />,
      },
      {
        path: RoutePaths.patientCreator,
        element: <PatientEditor mode="edit" />,
      },
      {
        path: RoutePaths.projectDashboard,
        element: <ProjectDashboard />,
      },
      {
        path: RoutePaths.projectEditor,
        element: <ProjectEditor />,
      },
      {
        path: RoutePaths.projectSelector,
        element: <ProjectSelector />,
      },
      {
        path: RoutePaths.userEditor,
        element: <UserEditor />,
      },
      {
        path: RoutePaths.users,
        element: <Users />,
      },
      {
        path: RoutePaths.export,
        element: <Export />,
      },
      {
        path: RoutePaths.profile,
        element: <Profile />,
      },
      {
        path: RoutePaths.patientDetails,
        element: <PatientDetails />,
      },
      {
        path: RoutePaths.reportTemplates,
        element: <ReportTemplates />,
      },
      {
        path: RoutePaths.reportTemplateEditor,
        element: <ReportTemplateEditor />,
      },
      {
        path: RoutePaths.forms,
        element: <ProjectFormLists />,
      },
      {
        path: RoutePaths.form,
        element: <Form mode="create" />,
      },
      {
        path: RoutePaths.formEdit,
        element: <Form mode="edit" />,
      },
      {
        path: RoutePaths.formView,
        element: <Form mode="view" />,
      },
      {
        path: RoutePaths.import,
        element: <Import />,
      },
    ],
  },
]);
